<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">Rock7</div>
              <q-btn
                class="q-ml-md"
                color="secondary"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="rock7sLoading"
                @click="$store.dispatch('rock7/loadAll')"
              >
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondary"
                text-color="accent"
                unelevated
                no-caps
                @click="downloadCSV"
              >
                <q-icon
                  name="mdi-download"
                  color="accent"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Download CSV
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="rock7s">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 160px) !important"
                >
                  <datatable
                    ref="dataTable"
                    :filter="search"
                    :flat="true"
                    :data="rock7s"
                    :columns="columns"
                    selection="multiple"
                    @rowDoubleClick="handleDoubleClick"
                  >
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="viewDetailsDialog" max-width="600px">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 90vw; max-width: 600px"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Entry #{{ viewFormData.id }}
            </div>
            <q-space />
            <q-btn
              color="accent2"
              round
              flat
              icon="mdi-close"
              @click="viewDetailsDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <rock7Form
            ref="editForm"
            :data="viewFormData"
            @close="viewDetailsDialog = false"
            @loadingStateChanged="(state) => (saveLoading = state)"
          />
        </q-card-section>
        <q-card-section> </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import datatable from "@/components/datatable/datatable.vue";
  import rock7Form from "@/components/rock7/rock7Form.vue";
  import moment from "moment";

  // import { Notify } from "quasar";

  export default {
    components: {
      datatable,
      rock7Form,
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        rock7s: "rock7/list",
        rock7sLoading: "rock7/listLoading",
        dateRange: "settings/dateRange",
      }),
    },
    data: () => ({
      // data-table
      columns: [
        {
          name: "id",
          label: "ID",
          align: "left",
          field: "id",
          sortable: true,
        },

        {
          name: "created_at",
          label: "Server upload time",
          align: "left",
          field: "created_at",
          format: (val) =>
            val != null
              ? moment.utc(val).local().format("DD-MMM, YYYY h:mma")
              : "",
          sortable: true,
        },
        {
          name: "request",
          label: "Request",
          align: "left",
          field: "request",

          sortable: false,
          style:
            "max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
        {
          name: "body",
          label: "Body",
          align: "left",
          field: "body",

          sortable: false,
          style: "width: 200px",
        },
      ],
      search: "",

      proxyDate: {
        from: null,
        to: null,
      },

      viewFormData: null,
      viewDetailsDialog: false,
    }),
    beforeCreate() {
      this.$store.dispatch("rock7/loadAll");
    },
    mounted() {},
    methods: {
      handleDoubleClick(row) {
        this.viewFormData = row;
        this.viewDetailsDialog = true;
      },
      updateProxy() {
        this.proxyDate = this.dateRange;
      },
      save() {
        this.$store.dispatch("settings/loadDateRange", this.proxyDate);
      },
      downloadCSV() {
        let filename = "Rock7Events.csv";

        let text = this.generateCSV(this.$refs.dataTable.selected);

        var element = document.createElement("a");
        element.setAttribute(
          "href",
          "data:text/plain;charset=utf-8," + encodeURIComponent(text)
        );
        element.setAttribute("download", filename);

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
      },
      generateCSV(devices) {
        const csvString = [
          Object.keys(devices[0]),
          ...devices.map((item) => Object.values(item)),
        ]
          .map((e) => e.join(","))
          .join("\n");

        return csvString;
      },
    },
  };
</script>

<style scoped lang="scss">
  #depthCard:hover {
    background: #5cb3ff;
    color: white;
  }

  .dateRangeText {
    font-size: 10pt;
    color: $accent;
  }
</style>
